var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booking-management"},[_c('div',{staticClass:"booking-management-action"},[_c('el-button',{attrs:{"type":"danger","icon":"el-icon-edit-outline"},on:{"click":function($event){return _vm.goPage({name: 'BookingAddNotes'})}}},[_vm._v("通知客服")]),_c('el-button',{attrs:{"type":"danger","icon":"el-icon-edit"},on:{"click":function($event){return _vm.goPage({
        name: 'BookingOrderManage',
        params: {
          type: 'edit',
        }
      })}}},[_vm._v("修改预约")]),_c('el-button',{attrs:{"type":"danger","icon":"el-icon-document-delete"},on:{"click":function($event){return _vm.goPage({
        name: 'BookingOrderManage',
        params: {
          type: 'cancel',
        }
      })}}},[_vm._v("取消预约")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }